<template>
  <div v-if="subcategory !== null">
    <!-- block -->
    <div class="block mb-5">
      <!-- SubCategory Name -->
      <label class="form-item pt-5 d-flex">
        <h4 class="w-240px mr-10">SubCategory Name <span class="text-danger">*</span></h4>
        <div class="w-248px my-n2">
          <v-text-field
            v-model="subcategory.name"
            placeholder="請輸入子分類名稱"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- BU -->
      <div class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">BU <span class="text-danger">*</span></h4>
        <div class="w-248px my-n2 category-autocomplete">
          <v-autocomplete
            v-model="subcategory.bu_id"
            :items="buTabs"
            placeholder="請選擇所屬BU"
            item-text="name"
            item-value="id"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
      </div>
      <!-- Category -->
      <div class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">Category <span class="text-danger">*</span></h4>
        <div class="w-248px my-n2 sub-category-autocomplete">
          <v-autocomplete
            v-model="subcategory.product_category_id"
            :items="categories"
            placeholder="請選擇所屬Category"
            item-text="name"
            item-value="id"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
      </div>
      <!-- ID -->
      <label class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">ID</h4>
        <div class="d-flex">
          <div class="form-input-group w-248px my-n2">
            <input type="text" :value="subcategory.id" disabled />
          </div>
          <div class="h5 ink-02-medium--text ml-10px">自動生成</div>
        </div>
      </label>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="w-248px my-n2">
          <v-text-field
            v-model="subcategory.order"
            placeholder="請輸入序號"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- 顯示/隱藏 -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4>顯示/隱藏</h4>
        </div>
        <div>
          <FormSwitch v-model="subcategory.status"></FormSwitch>
        </div>
      </label>
      <!-- 圖片 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">圖片</h4>
          <div class="h5 ink-02-medium--text">
            此圖將顯示於官網Category Page <br />
            建議尺寸：151px * 151px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div>
          <ImgUploader
            :imageUrl.sync="subcategory.image"
            dir="subcategory"></ImgUploader>
        </div>
      </div>
    </div>

    <!-- PageMenu -->
    <div class="block">
      <PageMenu :sections="sections">
        <component :is="sectionView"></component>
      </PageMenu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import PageMenu from '@/components/PageMenu.vue';

import TabSpec from '@/views/C-2__SubCategory/c/C-2-2-1__SubCategoryEdit_Spec.vue';
import TabFilter from '@/views/C-2__SubCategory/c/C-2-2-2__SubCategoryEdit_Filter.vue';
import MessagingHighlight from '@/views/C-2__SubCategory/c/C-2-2-3__SubCategoryEdit_Messaging&Highlight.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
    PageMenu,
    TabSpec,
    TabFilter,
    MessagingHighlight,
  },
  data: () => ({
    bus: [],
    categories: [],
    sections: [
      { name: 'Spec', component: 'TabSpec' },
      { name: 'Filter', component: 'TabFilter' },
      // { name: 'Messaging & Highlight', component: 'MessagingHighlight' },
    ],
  }),
  computed: {
    ...mapState(['currentBuTabId', 'buTabs']),
    ...mapState('subcategory', ['subcategory']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  async created() {
    if (this.subcategory.bu_id !== '' && this.subcategory.bu_id !== null) {
      this.categories = await this.getCategoriesByBu(this.subcategory.bu_id);
    }
  },
  watch: {
    async 'subcategory.bu_id'(newValue) {
      if (newValue !== '') {
        this.categories = await this.getCategoriesByBu(newValue);
      } else {
        this.categories = [];
      }
    },
  },
  methods: {
    ...mapActions('category', {
      getCategoriesByBu: 'allByBu',
    }),
  },
};
</script>

<style lang="scss">
.sub-category-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }
}
</style>
